"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Heart = void 0;
var heart_1 = require("./heart");
Object.defineProperty(exports, "Heart", { enumerable: true, get: function () { return heart_1.Heart; } });
//# sourceMappingURL=index.js.map